import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-42824ac4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "top"
};
const _hoisted_2 = {
  class: "navigation-tabs"
};
const _hoisted_3 = {
  class: "top-right"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_navigation_tabs = _resolveComponent("navigation-tabs");
  const _component_seller_filter = _resolveComponent("seller-filter");
  const _component_marketplace_filter = _resolveComponent("marketplace-filter");
  const _component_empty_segments = _resolveComponent("empty-segments");
  const _component_segment_filter = _resolveComponent("segment-filter");
  const _component_product_filter = _resolveComponent("product-filter");
  const _component_app_button = _resolveComponent("app-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [!$props.hideNavigationTabs ? (_openBlock(), _createBlock(_component_navigation_tabs, {
    key: 0,
    tabs: $options.computedTabs,
    modelValue: $options.tab,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.tab = $event)
  }, null, 8, ["tabs", "modelValue"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_seller_filter, {
    sellers: _ctx.sellers_filter,
    select_key: _ctx.sellers_filter.key,
    search_key: $data.sellers_filter_key,
    onApply: $options.applySellers,
    onCleared: $options.clearSellers
  }, null, 8, ["sellers", "select_key", "search_key", "onApply", "onCleared"]), _createVNode(_component_marketplace_filter, {
    marketplaces: _ctx.marketplaces_filter,
    select_key: _ctx.marketplaces_filter.key,
    search_key: $data.marketplaces_filter_key,
    onApply: $options.applyMarketplaces,
    onCleared: $options.clearMarketplaces
  }, null, 8, ["marketplaces", "select_key", "search_key", "onApply", "onCleared"]), _createVNode(_component_segment_filter, {
    segments: _ctx.segments_filter,
    onApply: $options.applySegments
  }, {
    empty: _withCtx(() => [_createVNode(_component_empty_segments)]),
    _: 1
  }, 8, ["segments", "onApply"]), _createVNode(_component_product_filter, {
    products: _ctx.products_filter,
    marketplaces: _ctx.marketplaces_filter,
    sellers: _ctx.sellers_filter,
    onApply: $options.applyProducts,
    onSearch: $options.searchProducts,
    onCleared: $options.clearProducts
  }, null, 8, ["products", "marketplaces", "sellers", "onApply", "onSearch", "onCleared"]), _ctx.selected_contents.length > 0 ? (_openBlock(), _createBlock(_component_app_button, {
    key: 0,
    onClick: $options.pushUpdates,
    version: "small",
    v2: "",
    class: "push-button"
  }, {
    default: _withCtx(() => [_createTextVNode(" Push " + _toDisplayString(_ctx.selected_contents.length) + " products", 1)]),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true)])]);
}